/* eslint-disable react/require-default-props */
/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
/* eslint no-underscore-dangle: 0 */
/* eslint-disable comma-dangle */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/control-has-associated-label */

import React, { useState, } from 'react';
import {
  Button,
  Form,
  Input,
  Layout,
  Drawer,
  Menu,
  Dropdown,
  Space,
  Typography,
} from 'antd';
import {
 DownOutlined, MenuOutlined, InstagramFilled, LinkedinFilled
} from '@ant-design/icons';
import { inject, observer, } from 'mobx-react';
import { useHistory, } from 'react-router-dom';
import './Header.less';
import useForm from 'antd/lib/form/hooks/useForm';
import { Toast, } from '..';
import utility from '../../Global/Utility';
import { Category, } from '../../Global/interface';
import rule from './contactUs.validation';
import contactService from '../../Services/contactService';
import categoryStore from '../../Store/categoryStore';
import kudLogo from '../../Assets/Images/KUD_Logo_White.png';
import GTranslate from '../Translation/index';
import Routes from '../../Global/Routes';
import Constant from '../../Global/Constant';

const { TextArea } = Input;

function Header() {
  const history = useHistory();
  const [open, setOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [form] = useForm();

  const showDrawer = () => {
    setOpen(true);
  };

  const showMenuDrawer = () => {
    setMenuOpen(true);
  };

  const onClose = () => {
    form.resetFields();
    setOpen(false);
  };

  const onMenuClose = () => {
    setMenuOpen(false);
  };

  const onSubmitForm = () => {
    form.validateFields()
      .then((values) => {
        sendContactReq(values);
      }).catch(() => { });
  };

  const sendContactReq = async (values: any) => {
    await contactService.sendContactUs(values)
      .then(() => {
        setOpen(false);
        form.resetFields();
        Toast.success(Constant.contactFormSubmitSuccess);
      })
      .catch((error: any) => Toast.error(error));
  };

  const goToHomePage = () => {
    categoryStore.setCategory(null);
    history.push(Routes.home);
  };

  const openMS365 = () => {
    window.open(Constant.ms365WebLink);
  };

  const redirectToProjects = (selectedCategory: Category) => {
    categoryStore.setCategory(selectedCategory);
    history.push(Routes.projects);
  };

  const categoriesMenu = () => (
    <Menu>
      {
        categoryStore.categories.length > 0 && categoryStore.categories.map((category: Category) => (
          <Menu.Item key={category._id} onClick={() => redirectToProjects(category)}>
            <Typography>{category.name}</Typography>
          </Menu.Item>
        ))
      }
    </Menu>
  );

  return (
    <Layout.Header id="header">
      <div className="d-flex">
        <div id="google_translate_element" />
        <div className="main-header">
          <div className="main-header-logo">
            <img src={kudLogo} alt="logo" onClick={() => goToHomePage()} aria-hidden="true" />
          </div>
          {
            categoryStore.category && (
              <div className="mainheader-gohome">
                <Dropdown overlay={categoriesMenu()}>
                  <Button type="text" style={{ backgroundColor: 'transparent', color: 'white' }} onClick={(e) => e.preventDefault()}>
                    <Space>
                      {categoryStore.category?.name} <DownOutlined />
                    </Space>
                  </Button>
                </Dropdown>
              </div>
            )
          }

          <div className="mainheader-language notranslate">
            <GTranslate />
          </div>
          <div className="mainheader-contactus">
            <Button className="antd-button" onClick={showDrawer}>Contact Us</Button>
            <Drawer className="apply-modal" title="Contact Us" placement="bottom" onClose={onClose} visible={open}>
              <div className="modal-inner-contactUs">
                <Form
                  layout="vertical"
                  onFinish={onSubmitForm}
                  form={form}
                  validateTrigger={['onBlur', 'onSubmit', 'onChange']}
                  scrollToFirstError
                >
                  <Form.Item label="First Name" name="first_name" rules={rule.first_name} normalize={utility.trimSpacesInValues}>
                    <Input />
                  </Form.Item>
                  <Form.Item label="Last Name" name="last_name" rules={rule.last_name} normalize={utility.trimSpacesInValues}>
                    <Input />
                  </Form.Item>
                  <Form.Item label="Email" name="email" rules={rule.email} normalize={utility.trimSpacesInValues}>
                    <Input />
                  </Form.Item>
                  <Form.Item label="Phone" name="phone" rules={rule.phone} normalize={utility.trimSpacesInValues}>
                    <Input />
                  </Form.Item>
                  <Form.Item label="Message" name="message" rules={rule.message} normalize={utility.trimSpacesInValues}>
                    <TextArea rows={4} />
                  </Form.Item>
                  <Form.Item>
                    <Button htmlType="submit">
                      Submit
                    </Button>
                  </Form.Item>
                  <hr />
                  <div>
                    <p><strong>Tel: </strong>  +965 22468247 / 48</p>
                    <p><strong>Fax: </strong>  +965 22462850</p>
                    <p><strong>Email: </strong>  kud@kudq8.com</p>
                    <p>
                      <a href="https://www.instagram.com/kud.kw/" className="instagram-icon"> <InstagramFilled style={{ fontSize: '40px' }} /></a>
                      <a href="https://www.linkedin.com/company/kuwait-united-development-company-k-s-c-c-kud" className="instagram-icon"> <LinkedinFilled style={{ fontSize: '40px' }} /></a>
                    </p>
                  </div>
                </Form>
              </div>
            </Drawer>
          </div>
          <div className="mainheader-email">
            <Button className="antd-button" onClick={openMS365}>Email Login</Button>
          </div>
          <Button type="default" className="mainheader-menu" onClick={showMenuDrawer}>
            <MenuOutlined />
          </Button>
        </div>
      </div>
      <Drawer className="menu-mobile" title="Menu" placement="right" onClose={onMenuClose} visible={menuOpen}>
        <nav>
          <a href="#" onClick={showDrawer}>Contact Us</a>
          <a href="#" onClick={openMS365}>Email Login</a>
          <a href="#" className="notranslate">
            <GTranslate />
          </a>
        </nav>
      </Drawer>
    </Layout.Header>
  );
}

export default inject('UIStore', 'userStore', 'tenantStore', 'categoryStore')(observer(Header));
